module.exports = __webpack_public_path__ + "img/nocontent.e51f0cf9.png";